<template>
    <!-- 弹窗提示 popupTips -->
    <div class='box'>
        <div class="boxTitle"><p>{{TipsTitle}}</p></div>
        <div class="boxContent" :style="Contentstyle"><pre>{{TipsText}}</pre></div>
        <div class="boxBtn"><van-button type="info" @click="PopupTipsShowBtn">确定</van-button></div>
    </div>
</template>
<script>
export default {
    name:'',
    data() {
        return {
            Contentstyle:""
        }
    },
    created(){
    },
    components:{},
    methods:{
        PopupTipsShowBtn(){
            this.$emit('PopupTipsShowBtn')
        }
    },
    props:{
        TipsText:{
            type:String
        },
        TipsTitle:{
            type:String
        },
        Contentheigth:{
            type:Number
        }
    },
    mounted(){
        this.Contentstyle = `height:${this.Contentheigth+"%"}`
    },
}
</script>
<style  scoped>
    .box{
        width: 90%;
        display: flex;
        flex-wrap: wrap;
        margin: 0 auto;
    }  
    .boxTitle{
        width: 100%;
        text-align: center;
        position: absolute;
        top: 0;
        
    }
    .boxTitle p{
        font-weight: 700;
        color: #333;
    }
    
    .boxContent{
        width: 90%;
        height: 60%;
        overflow: hidden;
        margin: .625rem auto;
        position: absolute;
        top: 3.125rem;
    }
    .boxContent pre{
    padding:0;
    line-height: 190%;
    margin: 0 0 1.75em;
    max-width: 100%;
    overflow: auto;
    white-space: pre;
    white-space: pre-wrap;
    display: block;
    word-wrap: break-word;
    overflow: auto;
    width: 90%;
    height: 100%;
    margin: 0 auto;

    }
    .boxBtn{
        width: 100%;
        position: absolute;
        bottom: .9375rem;
    }
     .boxBtn .van-button{
        width: 60%;
        border-radius: 1.25rem;
        margin: 0 auto;
        display: block;

     }
</style>